import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Spinner from "../app/shared/Spinner";
import { ROUTES } from "../utils/key_helper";
const UserManagement = lazy(() => import("./user-pages/user-management/UserManagement"));
const UserDetails = lazy(() => import("./user-pages/user-management/userdetails/UserDetails"));
const TradeDetails = lazy(() => import("./user-pages/user-management/tradedetails/TradeDetails"));
const CopierDetails = lazy(() => import("./user-pages/user-management/copierdetails/CopierDetails"));
const MasterStrategy = lazy(() => import("./user-pages/master-strategy/MasterStrategy"));
const StrategyDetails = lazy(() => import("./user-pages/master-strategy/strategydetails/StrategyDetails"));
const MailConfigs = lazy(() => import("./user-pages/mail-configs/MailConfigs"));
const Login = lazy(() => import("./auth-pages/Login"));
const Dashboard = lazy(() => import("./user-pages/dashboard/Dashboard"));
const NotFound = lazy(() => import("./user-pages/NotFound"));
const AppRoutes = () => {
	return (
		<Suspense fallback={<Spinner />}>
			<Routes>
				<Route path="*" element={<Navigate to={ROUTES.NOT_FOUND} />} />
				<Route path="/" element={<Navigate to={ROUTES.LOGIN} />} />
				<Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
				<Route path={ROUTES.LOGIN} element={<Login />} />
				<Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
				<Route path={ROUTES.USER_MANAGEMENT} element={<UserManagement />} />
				<Route path={ROUTES.USER_DETAILS()} element={<UserDetails />} />
				<Route path={ROUTES.USER_TRADE_DETAILS()} element={<TradeDetails />} />
				<Route path={ROUTES.USER_COPIER_DETAILS()} element={<CopierDetails />} />
				<Route path={ROUTES.STRATEGY} element={<MasterStrategy />} />
				<Route path={ROUTES.STRATEGY_DETAILS()} element={<StrategyDetails />} />
				<Route path={ROUTES.STRATEGY_TRADE_DETAILS()} element={<TradeDetails />} />
				<Route path={ROUTES.STRATEGY_COPIER_DETAILS()} element={<CopierDetails />} />
				<Route path={ROUTES.MAIL_CONFIG} element={<MailConfigs />} />
			</Routes>
		</Suspense>
	);
};

export default AppRoutes;
